import { darken } from '@mui/material'
import MuiAvatar from '@mui/material/Avatar'
import { Button } from 'reactstrap'
import styled from 'styled-components'

export const ContentFiltros = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  z-index: 5;

  & .tags-dropdown {
    position: absolute;
    background-color: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 0 8px 8px;
    z-index: 1000;
    min-width: 220px;
    max-height: 200px;
    overflow-y: auto;
  }

  & .tags-dropdown p {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 8px;
    position: sticky;
    top: 0;
    background-color: white;
    padding: 8px;
    &::after {
      content: '';
      position: absolute;
      bottom: -1px;
      left: 0;
      width: 100%;
      height: 1px;
      background-color: #ddd;
    }
  }

  & .tags-dropdown div {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  & .btn-filtro {
    background: none;
    border: none;
    box-shadow: none;
    padding: 0;
    margin: 0;
    font: inherit;
    color: inherit;
    cursor: pointer;

    display: flex;
    align-items: center;
    gap: 5px;
    padding: 5px 10px;
    border-radius: 8px;
    border: 1px solid #ddd;
    font-weight: 500;

    &:hover {
      background-color: #f0f0f0;
    }

    &.active {
      background-color: #cecece;
    }
  }
`

export const BoardContainer = styled.div`
  padding: 5px;
  min-height: calc(100vh - 400px);
  max-height: calc(100vh - 400px);
  overflow: auto;
  position: relative;
  z-index: 1;
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;

  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  & .react-kanban-board {
    display: flex !important;
    align-items: stretch !important;
    height: 100%;
    gap: 0px;
    min-width: max-content;
    padding-bottom: 5px;
    overflow: visible !important;
  }

  & .react-kanban-column {
    display: flex;
    flex-direction: column;
    flex: 1 !important;
    min-width: 300px;
    height: 100%;
    position: relative;
    padding-top: var(--kanban-header-height, 52px);
    font-family:
      ui-sans-serif,
      system-ui,
      sans-serif,
      'Apple Color Emoji',
      'Segoe UI Emoji',
      Segoe UI Symbol,
      'Noto Color Emoji';
    gap: 10px;
    background-color: rgba(240, 242, 244, 0.1) !important;
    border-radius: 8px !important;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08) !important;
    border: 1px solid #ddd !important;
    margin: 5px !important;
    overflow: visible;
  }

  & .react-kanban-column-header {
    position: relative;
    z-index: 1;
    background: #fff;
  }

  & .kanban-column-header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 2;
    background: #fff;
    transform: translateY(var(--kanban-header-offset, 0px));
    will-change: transform;
  }

  & .react-kanban-column-content {
    flex: 1;
    overflow: visible !important;
  }
`

interface CardContainerProps {
  borderColor?: string
}
export const CardContainer = styled.div<CardContainerProps>`
  position: relative;
  background-color: #fff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
  padding: 12px;
  margin: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  border-left: 4px solid ${(props) => props.borderColor || '#4caf50'};
  min-width: 300px;

  &:hover .action-buttons-container {
    display: flex;
  }
`

export const ActionButtonsContainer = styled.div`
  display: none;
  justify-content: space-around;
  align-items: center;
  margin-top: 10px;
  padding: 8px;
  border-top: 1px solid #ddd;
`

export const ActionButton = styled(Button)`
  background-color: transparent;
  border: solid 1px #ddd;
  border-radius: 12px;
  color: #000;
  font-size: 12px;
  padding: 4px 8px;
`

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Avatar = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #e8f5e9;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
`

export const CardTitle = styled.div`
  font-weight: 700;
  font-size: 12px;
`

interface CardTagProps {
  color?: string
}
export const CardTag = styled.span<CardTagProps>`
  background-color: transparent;
  color: ${(props) => props.color || '#1976d2'};
  border: 1px solid ${(props) => props.color || '#1976d2'};
  font-size: 11px;
  font-weight: 600;
  padding: 2px;
  border-radius: 10px;
  margin-left: 4px;
  width: fit-content;
`

const getAdjustedColor = (backgroundColor: string): string => {
  const brightness = parseInt(backgroundColor.replace('#', ''), 16)

  if (brightness < 0x7f7f7f) {
    return '#fff'
  }

  return darken(backgroundColor, 0.6)
}

interface CardBadgeProps {
  color?: string
}

export const CardBadge = styled.span<CardBadgeProps>`
  background-color: ${(props) => props.color || '#ffcdd2'};
  color: ${(props) => getAdjustedColor(props.color || '#ffcdd2')};
  border: 1px solid ${(props) => darken(props.color || '#ffcdd2', 0.6)};
  font-size: 12px;
  font-weight: 500;
  padding: 2px 6px;
  border-radius: 12px;
`

export const CardInfo = styled.span`
  color: #646e82;
  font-size: 0.825rem;
`

export const CardValue = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #000;
`

export const CardTime = styled.span`
  color: #777;
  font-size: 0.825rem;
`

export const ColumnHeader = styled.div<{ invalid?: boolean | null }>`
  padding: 10px;
  border-radius: 8px;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  position: sticky;
  top: 0;
  z-index: 2;
  background: #fff;
  min-width: 250px;
  transition: all 0.12s ease;
  opacity: ${(props) => (props.invalid ? 0.4 : 1)};
  border: ${(props) => (props.invalid ? '2px dashed red' : undefined)};

  &::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: #ddd;
  }
`

export const ColumnTitle = styled.span`
  font-size: 14px;
`

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0;
`

export const Section = styled.section`
  background: #fff;
  padding: 16px 8px;
`

export const SectionTitle = styled.h4`
  margin: 0 0 8px 0;
  font-size: 14px;
  color: #333;
`

export const LeadHeader = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
  padding: 8px;
`

export const LeadAvatar = styled(MuiAvatar)`
  width: 50px !important;
  height: 50px !important;
  background-color: #e9ecef !important;
  color: #212529 !important;
  font-size: 14px !important;
  font-weight: 700 !important;
`

export const LeadInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const LeadHeaderActions = styled.div`
  width: auto;
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: nowrap;

  @media (max-width: 768px) {
    margin-left: 0;
    width: auto;
  }
`

export const LeadHeaderSelect = styled.div`
  position: relative;
  width: 100%;
  flex: 1 0 100%;
  margin-top: 2px;

  @media (max-width: 768px) {
    margin-top: 0;
  }

  min-width: 100%;

  @media (max-width: 768px) {
    min-width: 100%;
  }
`

export const EtapaSelectContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 58px;
  width: 100%;
  padding: 10px 14px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    min-height: auto;
    padding: 12px;
  }
`

export const EtapaSelectLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
  color: #5f7490;
  font-size: 14px;
  font-weight: 700;

  & svg {
    font-size: 16px;
    color: #7b90a8;
  }

  @media (max-width: 768px) {
    font-size: 14px;
  }
`

export const EtapaSelectTrigger = styled.button`
  width: 100%;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  padding: 9px 12px;
  border: 1px solid #d9e3ee;
  border-radius: 10px;
  background: #ffffff;
  color: #1f2d3d;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  transition:
    border-color 0.12s ease,
    box-shadow 0.12s ease,
    background-color 0.12s ease;

  &:focus-visible {
    outline: none;
    border-color: #8fb0d6;
    box-shadow: 0 0 0 3px rgba(143, 176, 214, 0.2);
  }

  & svg {
    flex: 0 0 auto;
    font-size: 18px;
    opacity: 0.65;
  }
`

export const EtapaSelectValue = styled.span`
  display: inline-block;
  max-width: calc(100% - 26px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
`

export const EtapaSelectMenu = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 20;
  padding: 10px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.16);
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  max-height: 260px;
  overflow-y: auto;
`

export const EtapaSelectOption = styled.button<{ $active?: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  border: none;
  border-radius: 12px;
  background: ${(props) => (props.$active ? '#e8f1fb' : 'transparent')};
  color: ${(props) => (props.$active ? '#245b95' : '#334155')};
  font-size: 13px;
  font-weight: ${(props) => (props.$active ? 700 : 600)};
  text-align: left;
  transition:
    background-color 0.12s ease,
    color 0.12s ease;
  cursor: pointer;

  &:hover {
    background: ${(props) => (props.$active ? '#dceaf8' : '#f8fafc')};
  }

  & svg {
    font-size: 16px;
  }
`

export const LeadName = styled.span`
  font-weight: 700;
  font-size: 16px;
  color: #212529;
  text-transform: uppercase;
  letter-spacing: 0.3px;
`

export const LeadPhone = styled.span`
  font-size: 13px;
  color: #6c757d;
  margin-top: 2px;
`

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid #e9ecef;
  margin: 0 8px;
`

export const InfoGridTwoCol = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px 32px;
  padding: 8px;
`

export const InfoField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const InfoFieldLabel = styled.span`
  font-size: 11px;
  font-weight: 600;
  color: #8da4bf;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

export const InfoFieldValue = styled.span`
  font-size: 14px;
  color: #212529;
  font-weight: 500;

  &.pointer {
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
`

export const InfoGrid = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;
`

export const InfoList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const InfoItem = styled.div`
  display: flex;
  gap: 8px;
`

export const InfoKey = styled.div`
  color: #6c757d;
  min-width: 80px;
  font-size: 13px;
`

export const InfoValue = styled.div`
  color: #212529;
  font-size: 14px;
`

export const TagsWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
`

export const TagsLabel = styled.span`
  font-size: 11px;
  font-weight: 600;
  color: #8da4bf;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

export const Tag = styled.div`
  background: #f1f3f5;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  color: #333;
  border: 1px solid #dee2e6;
`

export const ActionButtonsRow = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  padding: 16px 8px;

  & > * {
    flex: 1 1 0;
    min-width: 0;
  }
`

export const HistoricoWrapper = styled.div`
  display: flex;
  align-items: center;
  background: #dddedf;
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  width: fit-content;
  gap: 12px;
  font-family: Arial, Helvetica, sans-serif;
  width: 100%;
`

export const IconArea = styled.div`
  color: #2ecc71;
  display: flex;
  align-items: center;
  font-size: 18px;
`

export const InfoArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const Title = styled.span`
  font-size: 14px;
  color: #333;
  white-space: pre-line;
`

export const MetaInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 12px;
  color: #777;
`

export const TitleKanban = styled.h2`
  font-size: 20px;
  font-weight: 700;
  margin: 0;
`

export const DescriptionKanban = styled.p`
  font-size: 14px;
  color: #555;
  margin: 4px 0 0 0;
`
